import React         from 'react';
import { Link }      from 'react-router-dom';
import { Countdown } from '../../../new-components';

const PromotionsItem = function(props) {
  const {
          activeFrom,
          activeTo,
          date,
          image,
          label,
          showCounter,
          urlKey,
        } = props;

  return (
    <Link className={'promotionItem'} to={`/akcii/${urlKey}`}>
      <img
        className={'promotionItem_img'}
        src={`${image}.png?default=horizontal&t=${BUILD_TIME}`}
        alt={label}
      />
      <div className={'promotionItem_time'}>
        <p className={'promotionItem_time_date'}>{date}</p>
        {showCounter && (
          <Countdown
            from={activeFrom}
            to={activeTo}
          />
        )}
      </div>
      <h3 className={'promotionItem_time_title'}>{label}</h3>
    </Link>
  );
};

export default PromotionsItem;
